import { api, parseApiError } from './api';
import type {
  Category,
  CategoriesListResponse,
  CreateCategoryInput,
  UpdateCategoryInput,
} from '@/types/category';

export const categoriesService = {
  /**
   * Get all categories (system + user custom)
   */
  async getCategories(): Promise<CategoriesListResponse> {
    try {
      const response = await api.get<CategoriesListResponse>('/api/categories');
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Create a custom category
   */
  async createCategory(data: CreateCategoryInput): Promise<Category> {
    try {
      const response = await api.post<Category>('/api/categories', data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Update a custom category
   */
  async updateCategory(id: string, data: UpdateCategoryInput): Promise<Category> {
    try {
      const response = await api.put<Category>(`/api/categories/${id}`, data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Delete a custom category
   */
  async deleteCategory(id: string): Promise<void> {
    try {
      await api.delete(`/api/categories/${id}`);
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default categoriesService;
